// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OP9Vv{position:relative}._1g8e8{position:absolute;top:-10%;right:-50px}", ""]);
// Exports
exports.locals = {
	"buttonLoadingTextClassName": "OP9Vv",
	"buttonLoadingSpinnerClassName": "_1g8e8"
};
module.exports = exports;
